import { useEffect } from "react";
import { Button, Container, Card, Col, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import businessDashboardSignal from "signals/BusinessDashboard.signal";
import {
  fetchAndSetDashboardData,
  getApplicationsMetrics,
  hideProgramsOfferedModal,
  loanChartOptions,
} from "./BusinessDashboard.helpers";
import BusinessWrapper from "../components/BusinessWrapper";
import ProgramsOfferedModal from "../components/ProgramsOfferedModal";
import { Doughnut, Pie } from "react-chartjs-2";
import { generalDoughnutChartWhiteTxtOptions } from "components/global/ChartJS/chartPresetsAndStyles";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ReactGA from "react-ga4";
import BusinessSavedOpportunities from "./components/BusinessSavedOpportunities";
import DelayedMount from "components/global/DelayedMount";

const BusinessDashboard = () => {
  const history = useHistory();
  const {
    applicationsMetrics,
    loanData,
    loanChartObj,
    favoriteRecords,
  } = businessDashboardSignal.value;

  useEffect(() => {
    fetchAndSetDashboardData();;
  }, [history.location.search]);

  useEffect(() => {
    getApplicationsMetrics();
  }, [loanData]);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: history.location.pathname,
      title: 'Business Dashboard',
    });
  }, []);

  return (
    <BusinessWrapper>
      {loanData?.length > 0 && (
        <DelayedMount>
        <Row className="px-8 py-16 mb-32 rounded">
          <Col lg={6} className="text-center text-light mr-8">
            <Card className="p-16" style={{ backgroundColor: '#294A6A' }}>
              <h5>Applications</h5>
              <Pie
                style={{ maxHeight: 300 }}
                data={applicationsMetrics}
                options={generalDoughnutChartWhiteTxtOptions}
                plugins={[ChartDataLabels]}
              />
            </Card>
          </Col>
          <Col className="text-center">
            <Card className="p-16 bg-white text-center h-100">
              <h5>Loans</h5>
              <Doughnut
                style={{ maxHeight: 300 }}
                data={loanChartObj}
                options={loanChartOptions}
                plugins={[ChartDataLabels]}
              />
            </Card>
          </Col>
        </Row>
        </DelayedMount>
      )}
      <Row className="mb-40">
        <Col>
          {favoriteRecords?.length > 0 ? (
            <BusinessSavedOpportunities />
          ) : 
          <Container 
            fluid 
            className="d-flex align-items-center justify-content-center bg-light"
            style={{ minHeight: '80vh' }}
          >
            <Row className="w-100 justify-content-center">
              <Col xs={12} md={10}>
                <Card className="shadow-lg border-0">
                  <Card.Body className="text-center px-5 py-5">
                    <Card.Title as="h2" className="font-weight-bold mb-4">
                      Funding Opportunities
                    </Card.Title>
                    <Card.Text className="text-muted lead mb-4">
                      Discover grants, loans, and financial programs tailored for small businesses. Get the support you need to grow and thrive.
                    </Card.Text>
                    <Button variant="primary" size="lg" href="/business/quick-matching">
                      Continue to Assessment
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        }
        </Col>
      </Row>
      <ProgramsOfferedModal
        onHide={hideProgramsOfferedModal}
        selectedOpportunity={businessDashboardSignal.value.selectedOpportunity}
        show={businessDashboardSignal.value.programsOfferedModalVisible}
      />
    </BusinessWrapper>
  );
};

export default BusinessDashboard;
